export const KycIncompleteCTemplate = {
    name: 'kyc_incomplete_3',
    label: 'KYC incomplete C',
    subject: "Rebit: فعالسازی حساب کاربری",
    category: 'reminders',
    body: "<div style='direction: rtl; font-family: tahoma' class='persian-text'>"
        + "<p>با درود و سپاس از ثبت‌نام شما،</p>"
        + "<p>شرکت Rebit طبق قوانین ضدپولشویی نیوزیلند موظف است قبل از ارائه خدمات مالی هویت مشتریان خود را تأیید کند.</p>"
        + "<p>چنانچه از متد Automatic در بخش verification سایت موفق به تکمیل احرازهویت و فعالسازی پروفایل خود نشده‌اید، می‌توانید مدارک و اطلاعات خود را با انتخاب روش Manual و تکمیل فرم مربوطه در بخش verification به ما ارسال کنید:</p>"
        + "<ol>"
        + "<li>تصویر پشت و روی گواهی‌نامه نیوزیلند یا پاسپورت ایران/نیوزیلند</li>"
        + "<li>آدرس محل سکونت به همراه address proof برای ساکنان نیوزیلند<br>" +
        "نظیر قبض برق/اینترنت یا proof of account و statement از سایت بانک." +
        "</li>"
        + "</ol>"
        + "<p>پس از ارسال مدارک بالا، ایمیل تأییدیه در کمتر از یک روز برای شما ارسال می‌گردد.</p>"
        + "<p>سپاس فراوان<br/>Rebit Money Transfer</p>"
        + "</div>"
}

